import type { IHttpParams } from '@/common/hooks/useHttp';
import { useMemo } from 'react';

import { useHttp } from '@/common/hooks/useHttp';
import { useDynamicForm } from '../../../context';

export const useFormHttp = (params: IHttpParams) => {
  const { httpParams, metadata } = useDynamicForm();

  const mergedParams = useMemo(() => {
    return {
      ...params,
      headers: {
        ...params.headers,
        ...httpParams?.headers,
      },
      params: {
        ...params.params,
        ...httpParams?.params,
      },
    };
  }, [httpParams, params]);

  return useHttp(mergedParams, metadata);
};
